/**
 * BuildInfo - Displays build fingerprint for debugging/verification
 * 
 * Shows:
 * - Build timestamp
 * - Git commit hash (if available)
 * - Environment indicator
 */

import React, { useEffect } from 'react';

const BUILD_TIMESTAMP = process.env.REACT_APP_BUILD_TIMESTAMP || 'dev';
const BUILD_COMMIT = process.env.REACT_APP_BUILD_COMMIT || 'local';
const BACKEND_URL = window.location.origin;

// Determine environment from URL
const getEnvironment = () => {
  if (BACKEND_URL.includes('localhost')) return 'local';
  if (BACKEND_URL.includes('preview.emergentagent')) return 'preview';
  if (BACKEND_URL.includes('staging')) return 'staging';
  return 'production';
};

export default function BuildInfo({ showInConsole = true, className = '' }) {
  const env = getEnvironment();
  
  // Log build info to console on mount
  useEffect(() => {
    if (showInConsole) {
      console.log(
        '%c🔧 UnityLove Build Info',
        'background: #6366f1; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;'
      );
      console.log(`   Timestamp: ${BUILD_TIMESTAMP}`);
      console.log(`   Commit:    ${BUILD_COMMIT}`);
      console.log(`   Env:       ${env}`);
      console.log(`   Backend:   ${BACKEND_URL}`);
    }
  }, [env, showInConsole]);
  
  return (
    <div className={`text-xs text-gray-400 dark:text-gray-500 ${className}`} data-testid="build-info">
      <span className="font-mono">
        Build: {BUILD_TIMESTAMP.slice(0, 16).replace('T', ' ')} UTC
      </span>
      {BUILD_COMMIT !== 'local' && (
        <span className="ml-2 font-mono">
          • {BUILD_COMMIT}
        </span>
      )}
      <span className={`ml-2 px-1.5 py-0.5 rounded text-[10px] uppercase tracking-wider ${
        env === 'production' ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400' :
        env === 'preview' ? 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400' :
        'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400'
      }`}>
        {env}
      </span>
    </div>
  );
}

// Compact version for footers
export function BuildInfoCompact({ className = '' }) {
  return (
    <span className={`text-[10px] text-gray-400 dark:text-gray-500 font-mono ${className}`}>
      {BUILD_TIMESTAMP.slice(0, 10)} • {BUILD_COMMIT}
    </span>
  );
}
